export default __webpack_public_path__ + "static/media/speakerActive.732bb246.svg";